/* ============================================================================
   DOHA SILVER STORE - New First Order Discount Popup JS
   Handles delayed display, exit-intent detection on desktop, escape key/backdrop closing,
   cookie checking/setting (30 days seen), and auto-reopening on form submission.
   ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('new-first-order-popup');
  if (!popup) return;

  const COOKIE_NAME = 'doha_popup_seen';

  /**
   * Helper to retrieve a cookie by name
   */
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  /**
   * Helper to set a cookie with a max-age in days
   */
  function setCookie(name, value, days) {
    document.cookie = `${name}=${value}; max-age=${days * 24 * 60 * 60}; path=/`;
  }

  let timerId = null;

  /**
   * Displays the popup, sets the cookie, binds keyboard listeners,
   * and cleans up other triggers to prevent double firing.
   */
  function showPopup() {
    popup.hidden = false;
    setCookie(COOKIE_NAME, 'true', 30);
    document.addEventListener('keydown', onKeydown);
    if (timerId) clearTimeout(timerId);
    document.removeEventListener('mouseout', onExitIntent);

    // Focus management for accessibility
    const autofocusEl = popup.querySelector('[autofocus]');
    if (autofocusEl) {
      autofocusEl.focus();
    } else {
      const emailInput = popup.querySelector('#PopupEmail');
      if (emailInput) emailInput.focus();
    }
  }

  /**
   * Closes the popup and unbinds keydown listeners
   */
  function closePopup() {
    popup.hidden = true;
    document.removeEventListener('keydown', onKeydown);
  }

  /**
   * Keyboard event handler for Escape key closing
   */
  function onKeydown(e) {
    if (e.key === 'Escape') closePopup();
  }

  /**
   * Exit intent event handler (detects cursor leaving top of viewport)
   */
  function onExitIntent(e) {
    if (e.clientY <= 0 && e.relatedTarget === null) {
      showPopup();
    }
  }

  // Setup click triggers for elements with [data-popup-close] (backdrop & close button)
  popup.querySelectorAll('[data-popup-close]').forEach((el) => {
    el.addEventListener('click', closePopup);
  });

  // If the user just successfully subscribed, reopen the popup immediately in success state
  if (popup.dataset.justSubscribed === 'true') {
    showPopup();
    return;
  }

  // If the cookie is already set, do not run timers or exit intent listeners
  if (getCookie(COOKIE_NAME)) return;

  // Initialize timer trigger
  const delayMs = Number(popup.dataset.delay) || 5000;
  timerId = setTimeout(showPopup, delayMs);

  // Initialize exit intent trigger for fine pointer (desktop) devices only
  if (window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mouseout', onExitIntent);
  }
});
